import './HighlightBanner.css';
import React from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import Spoiler from '../atoms/Spoiler/Spoiler';
import { get } from '../../utils';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil, isNotNil } from '../../utils/IsNil';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { hexToRgb } from '../../utils/hexToRgb';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var HighlightBanner = function HighlightBanner(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || "#035E88";
  var variables = {
    '--highlight-banner-background-with-opacity': hexToRgb(primaryPageThemeColor).concat(", 0.1")
  };
  var banner = get(fields, "data.item", []);
  var bannerTitle = get(banner, "title.jss.value");
  var bannerDescription = get(banner, "description.jss.value");
  var bannerCtaLink = get(banner, "ctaLink.jss.value.href");
  var bannerCtaTarget = get(banner, "ctaLink.jss.value.target");
  var bannerCtaLabelValue = get(banner, "ctaLabel.jss.value");
  var bannerImageSrc = get(banner, "image.jss.value.src");
  var bannerImageAlt = get(banner, "image.jss.value.alt");
  if (isNil(banner) || isNil(bannerTitle) || isNil(bannerDescription)) {
    console.warn('HighlightBanner component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HighlightBanner component is empty: please provide data source]");
    }
    return null;
  }
  var accordion = get(banner, "accordion", []).filter(function (el) {
    return el.title && el.title.jss.value && el.description && el.description.jss.value;
  });
  var renderAccordion = function renderAccordion(accordion) {
    if (Array.isArray(accordion) && !accordion.length) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "accordion__spoilers-wrapper"
    }, accordion.map(function (el, i) {
      var accordionTitle = el.title.jss.value;
      var accordionDescriptionJss = el.description.jss;
      var accordionCtaLinkHref = el.ctaLink && el.ctaLink.jss.value.href;
      var accordionCtaLinkTarget = el.ctaLink && el.ctaLink.jss.value.target;
      var accordionCtaLabelValue = el.ctaLabel && el.ctaLabel.jss.value;
      return /*#__PURE__*/React.createElement(Spoiler, {
        onToggle: function onToggle(val) {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["accordionAction"], params), [accordionTitle, val ? "expand" : "collapse"]);
        },
        key: i,
        title: accordionTitle
      }, /*#__PURE__*/React.createElement(RichText, {
        tag: "p",
        field: accordionDescriptionJss
      }), isNotNil(el.ctaLink) && el.ctaLink.jss.value.href && isNotNil(el.ctaLabel) && el.ctaLabel.jss.value && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["ctaClick"], params), [accordionTitle, el.ctaLabel ? el.ctaLabel.jss.value : ""]);
        },
        className: "accordion__cta",
        href: accordionCtaLinkHref,
        target: accordionCtaLinkTarget
      }, isNotNil(el.ctaLabel) ? accordionCtaLabelValue : null, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
        className: "btn-link__icon"
      }) : /*#__PURE__*/React.createElement(ChevronRight, {
        className: "btn-link__icon"
      })));
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: variables,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion accordion__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion__text-content"
  }, bannerTitle && /*#__PURE__*/React.createElement("h1", {
    className: "accordion__title"
  }, bannerTitle), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "accordion__description",
    field: banner.description.jss
  }), banner.ctaLink && bannerCtaLink && bannerCtaLabelValue && /*#__PURE__*/React.createElement("a", {
    className: "accordion__cta",
    href: bannerCtaLink,
    target: bannerCtaTarget
  }, banner.ctaLabel && bannerCtaLabelValue, rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon"
  })), renderAccordion(accordion)), isNotNil(banner.image) && bannerImageSrc && /*#__PURE__*/React.createElement("img", {
    className: "accordion__image",
    src: bannerImageSrc,
    alt: bannerImageAlt
  })));
};
export default HighlightBanner;
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    style = _ref2.style,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
var commonStyles = "cyl0sx8";
var rtlStyles = "r1uo9fef";
var ltrStyles = "lvgzgeq";